<template lang="pug">
.pagination
	.pagination__pages
		button(@click="setCurrentPage($event, 1)", :class="{ active: (currentPage !== 1) }") 1
		span.pagination__ellipses(v-if="showEllipses(2)") ...
		button(v-for="page in middlePagesShowing", @click="setCurrentPage($event, page)", :class="{ active: (currentPage !== page) }") {{ page }}
		span.pagination__ellipses(v-if="showEllipses(pageCount - 1)") ...
		button(v-if="pageCount !== 1", @click="setCurrentPage($event, pageCount)", :class="{ active: (currentPage !== pageCount) }") {{ pageCount }}
	.pagination__controls
		button.pagination__prev(:class="{ active: (currentPage !== 1) }", @click="setCurrentPage($event, currentPage - 1)")
			span Previous
		button.pagination__next(:class="{ active: (currentPage !== pageCount) }", @click="setCurrentPage($event, currentPage + 1)")
			span Next
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	name: 'Pagination',
	data() {
		return {
			pageCount: null
		}
	},
	watch: {
		filteredListings: function() {
			this.setPageCount();
		}
	},
	computed: {
		...mapGetters(["listingsData", "currentPage", "filteredListings"]),
		middlePagesShowing() {
			let middlePageArray = [];
			for (let i = 2; i < this.pageCount; i++) {
				middlePageArray.push(i);
			}
			if (middlePageArray.length > 3) {
				if (this.currentPage < 3) {
					middlePageArray = middlePageArray.slice(0, 2);
				} else if (this.currentPage === this.pageCount || this.currentPage === this.pageCount - 1) {
					middlePageArray = middlePageArray.slice(-2)
				} else {
					let currentIndex = middlePageArray.indexOf(this.currentPage);
					middlePageArray = middlePageArray.slice(currentIndex -1, currentIndex + 2);
				}
			}
			return middlePageArray
		},
	},
	methods: {
		...mapActions(["changePage"]),
		setPageCount() {
			if (this.filteredListings === null) {
				this.pageCount = Math.ceil(this.listingsData.listings.length / parseInt(this.$root.listingCount));
			} else {
				this.pageCount = Math.ceil(this.filteredListings.length / parseInt(this.$root.listingCount));
			}
		},
		setCurrentPage(e, pageNumber) {
			let listingAppContainer = e.target.closest(".listing-app");
			if (pageNumber > 0 && pageNumber <= this.pageCount && pageNumber !== this.currentPage) {
				listingAppContainer.scrollIntoView()
				this.changePage(pageNumber);
			}
		},
		showEllipses(num) {
			return (!this.middlePagesShowing.includes(num) && this.middlePagesShowing.length > 0 && this.pageCount > 5);
		}
	},
	mounted() {
		this.setPageCount();
	},
	updated() {
		this.setPageCount();
	}
}
</script>

<style scoped lang="scss">
button,
.pagination__ellipses {
	background: transparent;
	border: none;
	color: $darkGray;
	font-weight: 700;
	padding: 4px 2px;
	&.active {
		cursor: pointer;
	}
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	@include mqdn(sm) {
		justify-content: center;
		padding: 0.875rem 0;
	}
	&__pages {
		button,
		.pagination__ellipses {
			&:not(:last-child) {
				margin-right: 0.875rem;
			}
		}
		button {
			background-position: 0% 100%;
			&.active {
				@include linkHover;
				@include mqdn(md) {
					&:hover {
						background-size: 100% 1px;
						color: $darkGray;
					}
					&:active {
						background-size: 100% 100%;
						color: $white;
					}
				}
			}
		}
	}
	&__controls {
		display: flex;
		@include mqdn(sm) {
			display: none;
		}
		button {
			padding: 1rem;
			display: flex;
			align-items: center;
			background-position: 0% 100%;
			&:first-child {
				position: relative;
				&::before {
				@include icon;
				font-size: 1.625rem;
				color: $gray;
					content: '\e911';
					margin-right: 0.5rem;
				}
				&::after {
					content: '';
					position: absolute;
					height: 100%;
					width: 1px;
					background: $gray;
					top: 0;
					right: 0;
				}
			}
			&:last-child {
				&::after {
				@include icon;
				font-size: 1.625rem;
				color: $gray;
					content: '\e912';
					margin-left: 0.5rem;
				}
			}
			span {
				padding: 2px;
			}
			&.active {
				span {
					background-image: linear-gradient(to right, $red, $red);
					background-size: 100% 1px;
					background-position: 0% 100%;
					background-repeat: no-repeat;
					transition: 0.1s ease;
				}
				&:hover span {
					background-size: 100% 100%;
					color: $white;
				}
				@include mqdn(md) {
					&:hover span {
						background-size: 100% 1px;
						color: $darkGray;
					}
					&:active span {
						background-size: 100% 100%;
						color: $white;
					}
				}
			}
		}
	}
}
</style>
